import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { MdOutlineArrowForward } from "../assets/icons/vander";

export default function Privacy() {
  return (
    <>
      <Navbar navClass="justify-end nav-light" />
      <section className="relative table w-full py-36 bg-[url('../../assets/images/hero/bg.jpg')] bg-top bg-no-repeat bg-cover">
        <div className="absolute inset-0 bg-emerald-900/90"></div>
        <div className="container">
          <div className="grid grid-cols-1 text-center mt-10">
            <h3 className="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">
              Privacy Policy
            </h3>
          </div>
        </div>

        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="breadcrumb tracking-[0.5px] breadcrumb-light mb-0 inline-block">
            <li className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white/50 hover:text-white">
              <Link to="/index">HeroAcademi</Link>
            </li>
            <li
              className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white"
              aria-current="page"
            >
              Privacy Policy
            </li>
          </ul>
        </div>
      </section>
      <div className="relative">
        <div className="shape overflow-hidden z-1 text-white dark:text-slate-900">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <section className="relative lg:py-24 py-16">
        <div className="container">
          <div className="md:flex justify-center">
            <div className="md:w-3/4">
              <div className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                <h5 className="text-xl font-medium mb-4">Overview :</h5>
                <p className="text-slate-400">
                  We, at Hanko Holdings Limited and our affiliated
                  companies worldwide (hereinafter collectively referred to as
                  "HeroAcademi"), are committed to respecting your online
                  privacy and recognize the need for appropriate protection and
                  management of any personally identifiable information you
                  share with us. This Privacy Policy ("Policy") describes how
                  HeroAcademi collects, uses, discloses, and transfers personal
                  information of users through its websites and applications,
                  including through www.HeroAcademi.com, mobile applications,
                  and online services (collectively, the "Platform"). This
                  policy applies to those who visit the Platform, or whose
                  information HeroAcademi otherwise receives in connection with
                  its services (such as contact information of individuals
                  associated with HeroAcademi including partners) (hereinafter
                  collectively referred to as "Users"). For the purposes of the
                  Privacy Policy, "You" or "Your" shall mean the person who is
                  accessing the Platform.
                </p>
                <br />
                <p className="text-slate-400">
                  "Personal information" (PI) means any information relating to
                  an identified or identifiable natural person including common
                  identifiers such as a name, an identification number, location
                  data, an online identifier, or one or more factors specific to
                  the physical, physiological, genetic, mental, economic,
                  cultural, or social identity of that natural person and any
                  other information that is so categorized by applicable laws.
                  We collect information about you and/or your usage to provide
                  better services and offerings. The Personal Information that
                  we collect, and how we collect it, depends upon how you
                  interact with us.
                </p>

                <h5 className="text-xl font-medium mb-4 mt-8">
                  We collect the following categories of Personal Information in
                  the following ways:
                </h5>
                <ul className="list-unstyled text-slate-400 mt-4">
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Name, email, password, city, contact number, when you sign
                    up for alerts on the Platform
                  </li>
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Information usually included in a resume, including work
                    experience, education etc.,
                  </li>
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Information about the services that you use & how you use
                    them, including location
                  </li>
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    We use cookies to automatically collect, store, & use
                    technical information about your system
                  </li>
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    We may record any communications with us to ensure
                    compliance with our legal & regulatory obligations.
                  </li>
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Conducting market research and surveys with the aim of
                    improving our products and services.
                  </li>
                </ul>

                <h5 className="text-xl font-medium mb-4 mt-8">
                  Information Provided Voluntarily :
                </h5>
                <p className="text-slate-400">
                  We use information collected from cookies & other
                  technologies, to improve your user experience & the overall
                  quality of our services. When showing you tailored ads, we
                  will not associate an identifier from cookies or similar
                  technologies with sensitive categories, such as those based on
                  race, religion, sexual orientation, or health.
                </p>

                {/* <div className="mt-8">
                  <Link
                    to="#"
                    className="btn bg-indigo-600 hover:bg-indigo-700 text-white rounded-md"
                  >
                    Print
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
